import React from "react";
import "../text-input/styles.css";
import Text from "../typography/text.js";
import RequiredIcon from "../../icons/required-icon.js";
import ArrowIcon from "../../icons/arrow-down.js";

const TextInput = (props) => {
  const {
    titleText,
    isRequired,
    value,
    isDropdown,
    helperText,
    errorText,
    isDisabled,
    placeholder,
    setValue,
    className,
    parentClassName,
    type = "text",
    maxValue,
    onChange,
  } = props || {};

  const handleChange = (e) => {
    setValue(e.target.value);
  };

  return (
    <div className={`text-input-container ${parentClassName}`}>      
      {isRequired ? (
        <span
          className={isRequired ? "text-input-title" : ""}
        >
          <Text variant="tinyText">{titleText}</Text>
          {isRequired && <RequiredIcon />}
        </span>
      ) : (
        <Text variant="tinyText">{titleText}</Text>
      )}
      <div className={`text-input-box-container ${className}`}>
        {type === "number" ? (
          <input
            value={value?.label ? value?.label : value}
            onChange={onChange ?? handleChange}
            type="number"
            min={0}
            max={maxValue}
            required={isRequired}
            className={
              isDisabled ? "text-input-field disabled" : "text-input-field"
            }
            disabled={isDisabled}
            placeholder={placeholder}
          ></input>
        ) : (
          <input
            value={value?.label ? value?.label : value}
            onChange={onChange ?? handleChange}
            required={isRequired}
            className={
              isDisabled ? "text-input-field disabled" : "text-input-field"
            }
            disabled={isDisabled}
            placeholder={placeholder}
          ></input>
        )}
        {isDropdown && <ArrowIcon className="icon-container" />}
      </div>
      {helperText && (
        <Text variant="tinyText" color="lightText">
          {helperText}
        </Text>
      )}
      {errorText && (
        <Text variant="tinyText" color="failureColor">
          {errorText}
        </Text>
      )}
    </div>
  );
};

export default TextInput;
